import { provideCurrentContext } from '@rebuild/materials/shared/investment_activity/context';

export function useSelfContext() {
	provideCurrentContext({
		viewInHK09606: true
	});
}
